/**
 * Post Content Image Fallback Handler
 *
 * Detects broken post content images and delegates replacement to the renderer.
 */

import type { PostContentImageFallbackRender } from "./post-content-image-fallback-render";
import { postContentImageFallbackForm } from "./post-content-image-fallback-form";

class PostContentImageFallbackHandler {
    public render: PostContentImageFallbackRender;

    public constructor(render: PostContentImageFallbackRender) {
        this.render = render;
    }

    public handleImageError(target: HTMLImageElement): void {
        if (!(target instanceof HTMLImageElement)) return;
        if (!postContentImageFallbackForm.getClosestPostContent(target)) return;
        if (postContentImageFallbackForm.getClosestSnsContent(target)) return;

        this.render.replaceBrokenImage(target);
    }

    public scanBrokenImages(root: ParentNode): void {
        const images = postContentImageFallbackForm.getContentImages(root);
        images.forEach((img) => {
            if (postContentImageFallbackForm.getClosestSnsContent(img)) return;

            if (img.complete && img.naturalWidth === 0) {
                this.render.replaceBrokenImage(img);
            }
        });
    }
}

export { PostContentImageFallbackHandler };
